import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  ICreateCarreta,
  ICreateCarretaUpload,
  IEditCarreta
} from './carreta.model';

@Injectable({
  providedIn: 'root'
})
export class CarretaService {
  constructor(private http: HttpClient) {}

  CreateCarreta(body: ICreateCarreta, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}Carreta/CreateCarreta`,
      body,
      { headers: headers }
    );
  }

  CreateCarretaUpload(
    body: ICreateCarretaUpload,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}Carreta/CreateCarretasByUpload`,
      body,
      { headers: headers, responseType: 'text' as 'json' }
    );
  }

  public GetCarreta({
    placa,
    tipoCarreta,
    idEmpresa,
    pageNumber,
    pageSize,
    paginar = true,
    status = 1
  }: {
    placa?: string;
    tipoCarreta?: number;
    idEmpresa?: string;
    pageNumber?: number;
    pageSize?: number;
    paginar?: boolean;
    status?: number;
  }): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    const url = `${environment.baseURL}Carreta/GetCarretas`;
    const params: any = {};

    if (!invalid.includes(placa)) {
      params.TX_PLCA_CRRT = placa;
    }
    if (!invalid.includes(tipoCarreta)) {
      params.FK_TIPO_CRRT = tipoCarreta;
    }
    if (!invalid.includes(idEmpresa)) {
      params.FK_EPSA = idEmpresa;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }
    if (!paginar) {
      params.PAGE_SIZE = 2147483647;
    }

    params.NU_STTS_ALL = status;

    return this.http.get<any>(url, { params });
  }

  public GetCarretaById(id?: number): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    let url = `${environment.baseURL}Carreta/GetCarretaById`;

    if (!invalid.includes(id)) {
      url += `?id=${id}`;
    }

    return this.http.get<any>(url);
  }

  public EditarCarreta(pkCarreta: number, body: IEditCarreta): Observable<any> {
    const url = `${environment.baseURL}Carreta/UpdateCarreta?id=${pkCarreta}`;

    return this.http.put<any>(url, body);
  }

  public PatchCarretaEmpresa(
    carretaId: number,
    status: number
  ): Observable<any> {
    const url = `${environment.baseURL}Carreta/PatchCarretaStatus?id=${carretaId}`;

    const body = {
      NU_STTS_CRRT: status
    };

    return this.http.patch(url, body);
  }
}
